(() => {
  const STORAGE_KEY = 'vaNewsletterPopup';
  const ORIGIN_KEY = 'vaNewsletterOrigin';
  const DAY_MS = 86400000;
  const MS_PER_SECOND = 1000;
  const RETRY_DELAY_MS = 5000;
  const MAX_RETRY_COUNT = 12;
  const MOBILE_QUERY = '(max-width: 749px)';
  const SHEET_CLASS = 'is-sheet';
  const HIDE_FOCUS_CLASS = 'c-newsletter-popup--hide-focus';
  const LOCKED_BODY_CLASSES = ['overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet'];

  if (window.cNewsletterPopupReady) return;

  window.cNewsletterPopupReady = true;

  /** ストレージを安全に取得する。 */
  const getStorage = (storage, key) => {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  };

  /** ストレージを安全に保存する。 */
  const setStorage = (storage, key, value) => {
    try {
      storage.setItem(key, value);
    } catch (error) {}
  };

  /** 保存済み状態を返す。 */
  const getState = () => {
    const value = getStorage(localStorage, STORAGE_KEY);

    try {
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return null;
    }
  };

  /** 状態を保存する。 */
  const setState = (state) => {
    setStorage(localStorage, STORAGE_KEY, JSON.stringify(state));
  };

  /** デザインモードかを返す。 */
  const isDesignMode = () => Boolean(window.Shopify && window.Shopify.designMode);

  /** ハッシュ優先で送信元を返す。 */
  const getSubmittedFormId = () => {
    return window.location.hash.slice(1) || getStorage(sessionStorage, ORIGIN_KEY) || '';
  };

  /** ダイアログを開く。 */
  const openPopup = (dialog) => {
    if (dialog.open) return;

    if (matchMedia(MOBILE_QUERY).matches && dialog.classList.contains('c-newsletter-popup--sp-sheet')) {
      dialog.classList.add(SHEET_CLASS);
      dialog.classList.add(HIDE_FOCUS_CLASS);
      dialog.show();
      return;
    }

    dialog.classList.add(HIDE_FOCUS_CLASS);
    dialog.showModal();
    dialog.dataset.lockedScroll = 'true';
    document.body.classList.add('overflow-hidden');
  };

  /** ダイアログを閉じる。 */
  const closePopup = (dialog, shouldRecord) => {
    if (dialog.open) dialog.close();
    if (!shouldRecord || isDesignMode() || getState()?.state === 'subscribed') return;

    setState({ state: 'dismissed', at: Date.now() });
  };

  /** ポップアップを初期化する。 */
  const initPopup = (dialog) => {
    if (!dialog || dialog.dataset.initialized) return;

    dialog.dataset.initialized = 'true';

    const form = dialog.querySelector('form');
    const stateElement = dialog.querySelector('[data-newsletter-state]');

    dialog.querySelector('.c-newsletter-popup__close')?.addEventListener('click', () => {
      closePopup(dialog, true);
    });

    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') dialog.classList.remove(HIDE_FOCUS_CLASS);
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closePopup(dialog, true);
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closePopup(dialog, true);
    });

    dialog.addEventListener('close', () => {
      if (dialog.dataset.lockedScroll === 'true') {
        document.body.classList.remove('overflow-hidden');
        delete dialog.dataset.lockedScroll;
      }

      dialog.classList.remove(SHEET_CLASS);
    });

    form?.addEventListener('submit', () => {
      setStorage(sessionStorage, ORIGIN_KEY, dialog.dataset.formId);

      if (!isDesignMode()) setState({ state: 'dismissed', at: Date.now() });
    });

    if (stateElement && getSubmittedFormId() === dialog.dataset.formId) {
      if (stateElement.dataset.newsletterState === 'success' && !isDesignMode()) {
        setState({ state: 'subscribed', at: Date.now() });
      }

      openPopup(dialog);

      const focusTarget = stateElement.dataset.newsletterState === 'error'
        ? dialog.querySelector('input[name="contact[email]"]')
        : stateElement;

      focusTarget?.focus({ preventScroll: true });
      return;
    }

    if (stateElement) {
      stateElement.hidden = true;

      const input = dialog.querySelector('input[name="contact[email]"]');

      input?.removeAttribute('aria-invalid');
      input?.removeAttribute('aria-describedby');
      return;
    }

    if (isDesignMode()) return;

    const state = getState();
    const canReshow = state?.state !== 'dismissed'
      || Date.now() - state.at >= Number(dialog.dataset.reshowDays) * DAY_MS;

    if (
      dialog.dataset.autoOpen !== 'true'
      || dialog.dataset.subscribed === 'true'
      || state?.state === 'subscribed'
      || !canReshow
    ) return;

    const openWhenAvailable = (retryCount = 0) => {
      const activeTagName = document.activeElement?.tagName;
      const isFocused = ['INPUT', 'TEXTAREA', 'SELECT'].includes(activeTagName);
      const isLocked = LOCKED_BODY_CLASSES.some((className) => document.body.classList.contains(className));

      if (!isFocused && !isLocked) {
        openPopup(dialog);
        return;
      }

      if (retryCount >= MAX_RETRY_COUNT) return;

      setTimeout(() => openWhenAvailable(retryCount + 1), RETRY_DELAY_MS);
    };

    setTimeout(openWhenAvailable, Number(dialog.dataset.delay) * MS_PER_SECOND);
  };

  /** 指定範囲のポップアップを初期化する。 */
  const initPopups = (root = document) => {
    root.querySelectorAll('.c-newsletter-popup').forEach(initPopup);
  };

  /** 初回10%OFFの案内を表示できるときに表示する。 */
  const revealCouponNotes = (root = document) => {
    const dialog = document.querySelector('.c-newsletter-popup');

    if (!dialog || dialog.dataset.subscribed === 'true' || getState()?.state === 'subscribed') return;

    root.querySelectorAll('[data-c-coupon-note]').forEach((note) => {
      note.hidden = false;
    });
  };

  /** デザインモードの既存ポップアップを開く。 */
  const openDesignModePopups = () => {
    if (!isDesignMode()) return;

    document.querySelectorAll('.c-newsletter-popup').forEach(openPopup);
  };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const dialog = document.querySelector('.c-newsletter-popup[open]');

    if (dialog && !dialog.matches(':modal')) closePopup(dialog, true);
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-c-newsletter-open]')) return;

    const dialog = document.querySelector('.c-newsletter-popup');

    if (!dialog) return;

    const tagsInput = dialog.querySelector('input[name="contact[tags]"]');

    if (tagsInput && !tagsInput.value.split(',').includes('pdp_coupon')) {
      tagsInput.value += ',pdp_coupon';
    }

    openPopup(dialog);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initPopups();
      revealCouponNotes();
    });
  } else {
    initPopups();
    revealCouponNotes();

    // テーマエディタの再描画でページ読込後に挿入された場合だけ開く。
    if (document.readyState === 'complete') openDesignModePopups();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initPopups(event.target);
    revealCouponNotes(event.target);

    const dialog = event.target.querySelector('.c-newsletter-popup');

    if (isDesignMode() && dialog) openPopup(dialog);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const dialog = event.target.querySelector('.c-newsletter-popup');

    if (dialog) closePopup(dialog, false);
  });

  document.addEventListener('shopify:section:select', (event) => {
    const dialog = document.querySelector(
      `.c-newsletter-popup[data-section-id="${event.detail.sectionId}"]`,
    );

    if (dialog) openPopup(dialog);
  });

  document.addEventListener('shopify:section:deselect', (event) => {
    const dialog = document.querySelector(
      `.c-newsletter-popup[data-section-id="${event.detail.sectionId}"]`,
    );

    if (dialog) closePopup(dialog, false);
  });
})();
